enum EContentStatus {
    
    PASSIVE,
    ACTIVE,
    PREVIEW

}

export default EContentStatus;
